import React from "react";
import styled from "styled-components";

const Container = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #404040;
`;

const Message = styled.p`
  font-size: 1em;
  margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  min-width: 15em;
  text-align: center;
  margin: 0 auto;

  a {
    margin: 0 !important;
  }
`;

const NoReviewsState = ({ merchant, isCancelled }) => {
  const showWrite = !isCancelled && merchant.surveyUrl;

  const handleWriteClick = (e) => {
    e.preventDefault();
    window.open(merchant.surveyUrl, "Write a Review", "width=600,height=700");
  };

  return (
    <Container className="fdn-carousel-no-reviews">
      <Message>
        {isCancelled
          ? "There are no reviews yet."
          : "There are no reviews yet \u2014 you can be the first!"}
      </Message>
      {showWrite && (
        <ButtonWrapper className="button">
          <a
            href={merchant.surveyUrl}
            className="dmButtonLink dmWidget dmWwr default dmOnlyButton dmDefaultGradient"
            data-display-type="block"
            onClick={handleWriteClick}
          >
            <span className="text">Write a Review</span>
          </a>
        </ButtonWrapper>
      )}
    </Container>
  );
};

export default NoReviewsState;



// WEBPACK FOOTER //
// ./src/components/carousel/NoReviewsState.jsx